import { render } from "./CompletedCoursesView.vue?vue&type=template&id=34758083&scoped=true"
import script from "./CompletedCoursesView.vue?vue&type=script&lang=js"
export * from "./CompletedCoursesView.vue?vue&type=script&lang=js"

import "./CompletedCoursesView.vue?vue&type=style&index=0&id=34758083&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34758083"]])

export default __exports__